<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-sheet v-if="!loading && items.length" color="#f0f8fc">
        <v-container class="py-10 py-md-13 py-lg-16">
          <div
            class="
              primary--text
              text-h5 text-md-h4 text-center
              font-weight-bold
            "
          >
            Vídeos
          </div>

          <div class="mx-n3 mt-8">
            <CarouselWidget
              class="mt-8 mt-md-12 items"
              :items="items"
              :itemsToShow="itemsToShow"
              dots
              nav
            >
              <template #item="{ item }">
                <div class="px-3">
                  <VideoCard v-bind="item" />
                </div>
              </template>
            </CarouselWidget>
          </div>
        </v-container>
      </v-sheet>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import CarouselWidget from "../widgets/CarouselWidget.vue";
import VideoCard from "../cards/VideoCard.vue";

const _config = {
  mod: "videos",
};

export default {
  data: () => ({
    loading: true,
    itemsToShow: {
      xs: 1,
      sm: 2,
      md: 3,
      lg: 3,
      xl: 3,
    },
  }),
  created() {
    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
  },
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  components: {
    LoadingWidget,
    CarouselWidget,
    VideoCard,
  },
};
</script>
